/**
 * Replaces the classic "next page" pagination link in a collection grid with an
 * in-place AJAX append: clicking it fetches the next page's product grid and
 * appends the new cards to the current one, instead of reloading the whole page.
 * Falls back to a normal full-page navigation if JS fails or is unavailable,
 * since the underlying <a href> links are left untouched.
 */
class CollectionLoadMore extends HTMLElement {
  connectedCallback() {
    this.grid = document.getElementById('product-grid');
    this.status = this.querySelector('.collection-load-more__status');
    this.spinner = this.querySelector('.loading__spinner');
    this.loadingMoreLabel = window.accessibilityStrings?.loadingMoreProducts || '';
    this.bindNextLink();
  }

  bindNextLink() {
    // Dawn's pagination markup names the "next page" arrow ".pagination__item--prev"
    // (a pre-existing naming quirk in the shared pagination snippet, kept as-is here).
    const nextLink = this.querySelector('a.pagination__item--prev');
    if (!nextLink) return;
    nextLink.addEventListener('click', this.onNextClick.bind(this));
  }

  onNextClick(event) {
    if (this.loading || !this.grid) return;
    event.preventDefault();
    this.loading = true;

    const sectionId = this.grid.dataset.id;
    const url = new URL(event.currentTarget.href);
    url.searchParams.set('section_id', sectionId);

    this.classList.add('is-loading');
    if (this.spinner) this.spinner.classList.remove('hidden');
    if (this.status) this.status.textContent = this.loadingMoreLabel;

    fetch(url.toString())
      .then((response) => response.text())
      .then((html) => this.renderNewProducts(html))
      .catch((error) => {
        console.error(error);
        window.location.href = event.currentTarget.href;
      })
      .finally(() => {
        this.loading = false;
        this.classList.remove('is-loading');
        if (this.spinner) this.spinner.classList.add('hidden');
      });
  }

  renderNewProducts(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = parsedHTML.getElementById('product-grid');
    const newPagination = parsedHTML.querySelector('.collection-load-more');

    if (newGrid) {
      Array.from(newGrid.children).forEach((item) => this.grid.appendChild(item));
      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(this.grid);
      }
    }

    if (newPagination) {
      this.innerHTML = newPagination.innerHTML;
      this.status = this.querySelector('.collection-load-more__status');
      this.spinner = this.querySelector('.loading__spinner');
      this.bindNextLink();
    } else {
      this.remove();
    }

    if (this.status) this.status.textContent = '';
  }
}

customElements.define('collection-load-more', CollectionLoadMore);
